import MUIDataTable from 'mui-datatables'

// Igual a TableBase pero con paginado server-side (requiere count/page/rowsPerPage y sus handlers)
const TableBasePaginado = ({
  title = 'Tabla',
  columns,
  data,
  options,
  count = 0,
  page = 0,
  rowsPerPage = 20,
  rowsPerPageOptions = [10, 20, 50, 100],
  onChangePage,
  onChangeRowsPerPage
}) => {
  const optionsDefaults = {
      filterType: 'dropdown',
      responsive: 'standard',
      print: false,
      download: false,
      selectableRows:'none',
      serverSide: true,
      search: false,
      filter: false,
      sort: false,
      count,
      page,
      rowsPerPage,
      rowsPerPageOptions,
      onChangePage: (currentPage) => onChangePage?.(currentPage),
      onChangeRowsPerPage: (numberOfRows) => onChangeRowsPerPage?.(numberOfRows),
      textLabels: {
        body: {
          noMatch: "No se encontro ninguna coincidencia",
          toolTip: "Ordenar",
          columnHeaderTooltip: (column) => `Ordenar por ${column.label}`
        },
        pagination: {
          next: "Pagina Siguiente",
          previous: "Pagina Anterior",
          rowsPerPage: "Filas por Hoja:",
          displayRows: "de",
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Descargar CSV",
          print: "Imprimir",
          viewColumns: "Mostrar/Ocultar columnas",
          filterTable: "Filtrar",
        },
        filter: {
          all: "Todos",
          title: `Filtro : `,
          reset: "Restablecer",
        },
        viewColumns: {
          title: "Mostrar Columnas",
          titleAria: "Mostrar/Ocultar Columnas",
        },
        selectedRows: {
          text: "fila(s) seleccionadas",
          delete: "Eliminar",
          deleteAria: "Eliminar filas seleccionadas",
        },
    },
    ...options
  }
  return (
      <MUIDataTable
          title={title}
          data={data}
          columns={columns}
          options={optionsDefaults}
      />
  )
}

export default TableBasePaginado
